import { render } from "./TDContracts.vue?vue&type=template&id=71f14970"
import script from "./TDContracts.vue?vue&type=script&lang=js"
export * from "./TDContracts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__